const Disqualification = Object.freeze({
    PREGNANT: "pregnant",
    RECENT_HEART_ATTACK: "recent heart attack",
    COPD: "COPD",
    ASTHMA: "asthma",
    ARRHYTHMIA: "arrhythmia",
    TACHYCARDIA: "tachycardia",
    CHRONIC_KIDNEY_DISEASE: "chronic kidney disease",
    RECENT_IODINE_TREATMENT: "recent iodine treatment",
    CONTRAST_DYE_ALLERGY: "contrast dye allergy",
    HOLD_BREATH: "hold breath",
    YOUNG_NO_RISK_FACTORS: "young - no risk factors",
    YOUNG_WITH_RISK_FACTORS: "young - with risk factors",
    HEART_BLOCK: 'heart block',
    HEART_FAILURE: 'heart failure',
})

export default Disqualification